module.exports = __webpack_public_path__ + "img/4.e5a4ae8c.jpg";